import { SVGProps } from 'react';
import * as React from 'react';

export const CityInboundIcon = (props: SVGProps<SVGSVGElement>): JSX.Element => (
  <svg
    {...props}
    width="20"
    height="21"
    viewBox="0 0 20 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_3554_1786)">
      <mask
        id="mask0_3554_1786"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="20"
        height="21">
        <rect y="0.5" width="20" height="20" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_3554_1786)">
        <path
          d="M2.58065 8.02202V6.5115H3.9363V5.39134H2.58065V3.88081H1.34749V5.39134H0V6.5115H1.34749V8.02202H2.58065ZM7.66844 8.91306C8.22376 8.91306 8.80359 8.78577 9.19559 8.5821V7.32616C8.69743 7.49589 8.2401 7.58075 7.79094 7.58075C6.84361 7.58075 6.50061 7.08855 6.50061 5.72229C6.50061 4.28815 6.82728 3.79595 7.78277 3.79595C8.24826 3.79595 8.71376 3.8893 9.18742 4.08448V2.71822C8.70559 2.5485 8.2401 2.47213 7.73377 2.47213C6.87628 2.47213 6.14945 2.70974 5.62679 3.1595C4.98163 3.72807 4.67946 4.54273 4.67946 5.73927C4.67946 6.72365 4.88363 7.44497 5.30012 7.96262C5.79012 8.57362 6.64761 8.91306 7.66844 8.91306ZM10.6411 3.79595C11.0902 3.79595 11.4251 3.44802 11.4251 2.98129C11.4251 2.51456 11.0902 2.16663 10.6411 2.16663C10.2001 2.16663 9.85708 2.51456 9.85708 2.9728C9.85708 3.44802 10.1837 3.79595 10.6411 3.79595ZM11.4251 8.78577V4.07599H11.0494C10.8616 4.26269 10.4941 4.35604 9.86525 4.37301V8.78577H11.4251ZM14.1527 8.87912C14.5202 8.87912 14.855 8.8282 15.1409 8.71788V7.55529L15.051 7.58075C14.8142 7.65712 14.7407 7.66561 14.5855 7.66561C14.1854 7.66561 14.071 7.5468 14.071 7.10553V5.32345H15.0674V4.21177H14.071V3.16798H12.9359L12.7971 3.68563C12.6991 4.05902 12.4786 4.21177 12.0376 4.21177H11.9641V5.32345H12.5112V7.31768C12.5112 8.42936 12.9849 8.87912 14.1527 8.87912ZM17.501 10.5L20 4.21177H18.6525L17.795 6.52847L16.9375 4.21177H15.3124L17.0519 8.4039L16.1535 10.5H17.501Z"
          fill="#191F25"
        />
        <path
          d="M9.47917 15.9166L6.04081 13V15.1875H0V16.6458H6.04081V18.8333L9.47917 15.9166ZM12.7865 17.5573C13.6925 17.5573 14.4271 16.8227 14.4271 15.9166C14.4271 15.0105 13.6925 14.276 12.7865 14.276C11.8804 14.276 11.1458 15.0105 11.1458 15.9166C11.1458 16.8227 11.8804 17.5573 12.7865 17.5573Z"
          fill="#191F25"
        />
        <path
          d="M9.47917 15.9166L6.04081 13V15.1875H0V16.6458H6.04081V18.8333L9.47917 15.9166ZM12.7865 17.5573C13.6925 17.5573 14.4271 16.8227 14.4271 15.9166C14.4271 15.0105 13.6925 14.276 12.7865 14.276C11.8804 14.276 11.1458 15.0105 11.1458 15.9166C11.1458 16.8227 11.8804 17.5573 12.7865 17.5573Z"
          fill="#191F25"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_3554_1786">
        <rect width="20" height="20" fill="white" transform="translate(0 0.5)" />
      </clipPath>
    </defs>
  </svg>
);
